import { render, staticRenderFns } from "./HeaderMarkTheExam.vue?vue&type=template&id=245c2ce8&scoped=true"
import script from "./HeaderMarkTheExam.vue?vue&type=script&lang=js"
export * from "./HeaderMarkTheExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c2ce8",
  null
  
)

export default component.exports